import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type Satisfaction = '1'|'2'|'3'|'4'|'5';

export type SatisfactionRequestData = {
    // 報修單號
    name: string,
    // 滿意度
    satisfaction: Satisfaction,
    // 意見回饋
    feedback: string,
};

function satisfaction(data: SatisfactionRequestData): Promise<DefaultResponseData> {
    return fetchData('api/satisfaction', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { satisfaction };
